"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signup = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var classnames_1 = require("classnames");
var SignupAction_1 = require("@/pages/common/actions/SignupAction");
var LoginAction_1 = require("@/pages/common/actions/LoginAction");
var SignupFormComponent_1 = require("@/pages/common/components/SignupFormComponent");
var mapStateToProps = function (state) { return state.signup; };
var mapDispatchToProps = function (dispatch) { return ({
    onSignupSubmit: function (signupFields) {
        return dispatch(SignupAction_1.default.onSignupSubmit(signupFields));
    },
    onSignupCloseClick: function () {
        return dispatch(SignupAction_1.default.onSignupCloseClick());
    },
    onSignupLoginClick: function () {
        return dispatch(SignupAction_1.default.onSignupLoginClick());
    },
    facebookLogin: function () { return dispatch(LoginAction_1.default.facebookLogin()); },
}); };
exports.signup = function (props) {
    var classnames = classnames_1.default([
        'l-fullscreen-dim',
        'l-fullscreen-dim--center',
        'c-login',
        {
            'c-login--active': props.isActive,
            'l-fullscreen-dim--active': props.isDim,
        },
    ]);
    var onSignupPanelClick = function (event) {
        if (event.currentTarget !== event.target)
            return;
        props.onSignupCloseClick();
    };
    var onClickedLogin = function () {
        props.onSignupLoginClick();
    };
    return (React.createElement("div", { id: "signup-panel", className: classnames, onClick: onSignupPanelClick },
        React.createElement("div", { className: "c-login__main" },
            React.createElement("a", { className: "c-login__close", onClick: props.onSignupCloseClick },
                React.createElement("span", { className: "fal fa-times" })),
            React.createElement("div", { className: "c-login__title" },
                React.createElement("div", { className: "c-page-header c-page-header--center" },
                    React.createElement("div", { className: "c-page-header__body" },
                        React.createElement("div", { className: "c-page-header__title" }, props.t.nameTitle),
                        React.createElement("div", { className: "c-page-header__caption" }, props.t.nameCaption)))),
            React.createElement(SignupFormComponent_1.default, { form: props.signupFields, tForm: props.tForm, ui: { isLoading: props.isLoading }, errors: props.errors, onFormSubmit: props.onSignupSubmit }),
            React.createElement("div", { className: "c-login__or" },
                React.createElement("span", { className: "c-login__or-line" }),
                props.t.nameOr,
                React.createElement("span", { className: "c-login__or-line" })),
            React.createElement("div", { className: "c-login__federal" },
                React.createElement("div", { className: "c-form__row " },
                    React.createElement("div", { className: "c-form__actions c-form__actions--center" },
                        React.createElement("button", { onClick: props.facebookLogin, className: "o-btn o-btn--facebook o-btn--long", type: "submit" }, props.t.nameFacebook)))),
            React.createElement("div", { className: "c-login__signup" },
                props.t.nameHaveAccount,
                React.createElement("a", { onClick: onClickedLogin, className: "o-textbtn" }, props.t.nameLogin)))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.signup);
